export const CREATE_TRIAGE_AGENT_CONFIGURATION_TEXT = 'Customize the agent'
export const CONFIG_FILE_NOT_FOUND_TEXT = 'Add configuration file (required)'
export const CONFIG_FILE_FOUND_TEXT = 'Edit custom instructions'
export const CONFIG_FILE_INVALID_TEXT = 'Configuration is invalid'
export const PAUSE_AGENT_TEXT = 'Pause the agent'
export const RESUME_AGENT_TEXT = 'Start the agent'
export const VIEW_DOCUMENTATION_TEXT = 'View documentation'
export const GIVE_FEEDBACK_TEXT = 'Give feedback'
export const TRIAGE_AGENT_TITLE = 'Triage agent'
export const TRIAGE_AGENT_DOCS_URL = 'https://docs.github.com/en/early-access/copilot/triage-agent'
export const TRIAGE_AGENT_FEEDBACK_URL = 'https://forms.office.com/r/P9bsiUn167'
export const TRIAGE_AGENT_PERMISSION_MESSAGE =
  'The Triage agent can be managed by users with the Maintainer role or higher.'
export const DEBUG_TRIAGE_TEXT = 'Debug triage'

export type TriageState = 'inactive' | 'active' | 'warning'

export const TRIAGE_BUTTON_TEXT: Record<TriageState, string> = {
  inactive: 'Enable triage',
  active: 'Triage agent',
  warning: 'Triage invalid',
}
